import React from 'react';
import { Button } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import GoogleIcon from '@mui/icons-material/Google';
import { useGoogleLogin } from '../../../hooks/useGoogleLogin';

const SocialButtons = () => {
    const { login } = useGoogleLogin();

    return (
        <>
            <Button className="btn-primary-2" variant="contained" startIcon={<FacebookIcon />} fullWidth sx={{ mb: 1, backgroundColor: '#1877F2', textTransform: 'none' }}>
            Entre com o Facebook
            </Button>
            <Button className="btn-primary-2" onClick={login} variant="outlined" startIcon={<GoogleIcon />} fullWidth sx={{ textTransform: 'none' }}>
            Entre com o Google
            </Button>
        </>
    )

};

export default SocialButtons;
